import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../Assets/SportsForEquity-Logo.png';
import impactJourneyImg from '../Assets/WA-State-Parksinsons-2025-2.jpeg';
import impactJourneyImg2 from '../Assets/USNationals2026OutReach.jpeg';
import '../Css/Footer.css';

/*
 * Paste your deployed Google Apps Script Web App URL here.
 * (See NEWSLETTER-SETUP / the Code.gs file for how to create it.)
 * Submitted emails are appended to your Google Sheet so you can email
 * subscribers later.
 */
const NEWSLETTER_ENDPOINT =
  'https://script.google.com/macros/s/AKfycbw4eY8n8b6IoA8z0Z6Y6UocG9FS3mcbQ3E7361up_ThTPTs4QMA2x4DnG_A8vbooFmA/exec';

const Footer = () => {
  const [modalContent, setModalContent] = useState('');
  const [modalTitle, setModalTitle]     = useState('');
  const [isOpen, setIsOpen]             = useState(false);

  /* Reset page scroll whenever a footer link is clicked, so the user always
     lands at the top of the destination page (instead of mid-page from
     React Router preserving scroll position). */
  const scrollToTop = () =>
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

  /* ── Newsletter ("Stay in the loop") ── */
  const [email, setEmail]   = useState('');
  const [status, setStatus] = useState('idle'); // idle | submitting | success | info | error
  const [notice, setNotice] = useState('');

  const isValidEmail = (value) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
  };

  // Calls the Apps Script Web App over JSONP so the browser can read the
  // response without hitting CORS restrictions.
  const subscribeViaJsonp = (params) =>
    new Promise((resolve, reject) => {
      const callbackName = `sfeNewsletterCb_${Date.now()}_${Math.floor(
        Math.random() * 1000000
      )}`;
      const script = document.createElement('script');
      let settled = false;

      const cleanup = () => {
        delete window[callbackName];
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      };

      const timer = setTimeout(() => {
        if (settled) return;
        settled = true;
        cleanup();
        reject(new Error('timeout'));
      }, 12000);

      window[callbackName] = (data) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        cleanup();
        resolve(data);
      };

      const query = new URLSearchParams({
        ...params,
        callback: callbackName,
      }).toString();

      script.src = `${NEWSLETTER_ENDPOINT}?${query}`;
      script.onerror = () => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        cleanup();
        reject(new Error('network'));
      };
      document.body.appendChild(script);
    });

  const handleSubscribe = async () => {
    const trimmed = email.trim();

    if (!isValidEmail(trimmed)) {
      setStatus('error');
      setNotice('Please enter a valid email address.');
      return;
    }

    setStatus('submitting');
    setNotice('');

    try {
      const data = await subscribeViaJsonp({
        email: trimmed,
        source: 'footer-stay-in-the-loop',
      });

      if (data && data.ok === false) {
        setStatus('error');
        setNotice(
          data.error === 'invalid_email'
            ? 'Please enter a valid email address.'
            : 'Something went wrong. Please try again.'
        );
        return;
      }

      if (data && data.duplicate) {
        setStatus('info');
        setNotice("You're already on our list — thanks for staying with us!");
      } else {
        setStatus('success');
        setNotice("Thanks! You're now on the list.");
        setEmail('');
      }
    } catch (err) {
      setStatus('error');
      setNotice('Something went wrong. Please try again.');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubscribe();
    }
  };

  const openModal = (title, content) => {
    setModalTitle(title);
    setModalContent(content);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setModalContent('');
    setModalTitle('');
  };

  const policies = [
    {
      label: 'Medical Disclaimer',
      title: 'Medical Disclaimer',
      body: 'SportsForEquity programs are designed to support community wellness, movement, and social connection. They are not medical treatment, physical therapy, or a substitute for advice from a qualified healthcare professional. Participants should consult their healthcare provider before beginning any new physical activity and take part only at a level that feels safe and appropriate.',
    },
    {
      label: 'Privacy Policy',
      title: 'Privacy Policy',
      body: 'We value your privacy. Any personal information you provide to us, such as your name or email address, will be used solely for communication or service delivery purposes. We do not share your data with third parties without your consent, except when required by law. Our website may collect anonymized usage data to improve user experience. By using this site, you consent to our privacy practices.',
    },
    {
      label: 'Cookies',
      title: 'Cookie Policy',
      body: 'This website uses cookies to enhance your browsing experience. Cookies help us understand how users interact with our content, allowing us to improve performance and functionality. You can choose to accept or decline cookies at any time through your browser settings. Continued use of the site implies consent to our use of cookies.',
    },
    {
      label: 'Terms & Conditions',
      title: 'Terms & Conditions',
      body: 'By accessing and using this website, you agree to comply with the following terms: All content is for informational purposes only. You may not reproduce, modify, or distribute our content without permission. We reserve the right to modify these terms at any time. Continued use of the site constitutes acceptance of any changes.',
    },
  ];

  return (
    <>
      <footer className="footer">

        {/* ── Begin your impact journey (CTA banner) ── */}
        <div className="footer-impact">
          <div className="footer-impact-inner">
            <div className="footer-impact-text">
              <h3 className="footer-impact-title">Bring SportsForEquity to your community</h3>
              <p className="footer-impact-line">
                Are you or others in your community interested in having a local SportsForEquity program?
              </p>
              <p className="footer-impact-line">
                Do you know others struggling with Parkinson's that could benefit from SportsForEquity?
              </p>
              <p className="footer-impact-line">
                Please join a class or engage our SportsForEquity team.
              </p>
              <Link
                to="/get-involved/join-us"
                className="footer-impact-btn"
                onClick={scrollToTop}
              >
                Contact
              </Link>
            </div>

            <div className="footer-impact-media">
              <div className="footer-impact-media-wrapper">
                <img
                  src={impactJourneyImg}
                  alt="SportsForEquity Parkinson's community session"
                  className="footer-impact-img"
                  loading="lazy"
                />
              </div>
              <div className="footer-impact-media-wrapper">
                <img
                  src={impactJourneyImg2}
                  alt="SportsForEquity US Nationals 2026 outreach"
                  className="footer-impact-img"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>

        {/* ── Stay in the loop (newsletter) ── */}
        <div className="footer-newsletter">
          <div className="footer-newsletter-text">
            <h3 className="footer-newsletter-title">Subscribe to our Newsletter</h3>
            <p className="footer-newsletter-sub">
              Get program updates, event announcements, and community
              highlights delivered to your inbox.
            </p>
          </div>

          <div className="footer-newsletter-action">
            <div className="footer-newsletter-form">
              <input
                type="email"
                className="footer-newsletter-input"
                placeholder="you@email.com"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (status !== 'idle') {
                    setStatus('idle');
                    setNotice('');
                  }
                }}
                onKeyDown={handleKeyDown}
                aria-label="Email address"
              />
              <button
                type="button"
                className="footer-newsletter-btn"
                onClick={handleSubscribe}
                disabled={status === 'submitting'}
              >
                {status === 'submitting' ? 'Submitting…' : 'Subscribe'}
              </button>
            </div>
            {notice && (
              <p
                className={`footer-newsletter-notice${
                  status === 'error'
                    ? ' is-error'
                    : status === 'info'
                    ? ' is-info'
                    : ' is-success'
                }`}
              >
                {notice}
              </p>
            )}
          </div>
        </div>

        <div className="footer-newsletter-divider" />

        <div className="footer-inner">

          {/* Brand column */}
          <div className="footer-brand">
            <div className="footer-brand-top">
              <Link to="/" onClick={scrollToTop}>
                <img src={logo} alt="SportsForEquity Logo" className="footer-logo" />
              </Link>
              <span className="footer-brand-name">
                Sports<span className="footer-brand-accent">For</span>Equity
              </span>
            </div>
            <p className="footer-tagline">
              Using table tennis to drive public health equity — 100% athlete-led.              
            </p>
            <a href="mailto:info@sportsforequity.live" className="footer-email">
              info@sportsforequity.live
            </a>
            {/* Social Icons */}
            <div className="footer-social-icons">
              {/* LinkedIn */}
              <a
                href="https://www.linkedin.com/company/sportsforequityorg"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="LinkedIn"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="35" height="35">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Nav columns */}
          <div className="footer-nav-group">
            <div className="footer-nav-cols-row">
              <div className="footer-nav-col">
                <span className="footer-nav-heading">Explore</span>
                <Link to="/"                            className="footer-nav-link" onClick={scrollToTop}>Home</Link>
                <Link to="/research"                    className="footer-nav-link nav-highlight-btn" onClick={scrollToTop}>Why Table Tennis?</Link>
                <Link to="/programs/PingPongParkinson"  className="footer-nav-link" onClick={scrollToTop}>PingPongParkinson</Link>
                <Link to="/programs/CommunityOutreach"   className="footer-nav-link" onClick={scrollToTop}>Community Outreach</Link>
                <Link to="/programs/YouthEmpowerment"    className="footer-nav-link" onClick={scrollToTop}>Youth Empowerment</Link>
                <Link to="/programs/HealthEquitySupport" className="footer-nav-link" onClick={scrollToTop}>Health Equity Support</Link>
                <Link to="/innovation-pongai"            className="footer-nav-link" onClick={scrollToTop}>Innovation &amp; PongAICoach</Link>
                <Link to="/Events"                      className="footer-nav-link" onClick={scrollToTop}>Events Gallery</Link>
                <Link to="/impact-stories"              className="footer-nav-link" onClick={scrollToTop}>Impact Stories</Link>
                <Link to="/research-advocacy"           className="footer-nav-link" onClick={scrollToTop}>Research & Advocacy</Link>
                <Link to="/Blogs"                       className="footer-nav-link" onClick={scrollToTop}>Media</Link>
              </div>
              <div className="footer-nav-col">
                <span className="footer-nav-heading">Contact</span>
                <Link to="/get-involved/join-us"     className="footer-nav-link" onClick={scrollToTop}>Contact</Link>
                <Link to="/about"                    className="footer-nav-link" onClick={scrollToTop}>About</Link>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <span className="footer-copy">© 2024 SportsForEquity. All rights reserved.</span>
          <div className="footer-policy-links">
            {policies.map((p) => (
              <button
                key={p.label}
                onClick={() => openModal(p.title, p.body)}
                className="footer-policy-btn"
              >
                {p.label}
              </button>
            ))}
          </div>
        </div>
      </footer>

      {/* Modal */}
      {isOpen && (
        <div className="footer-modal-overlay" onClick={closeModal}>
          <div className="footer-modal" onClick={(e) => e.stopPropagation()}>
            <div className="footer-modal-header">
              <h3 className="footer-modal-title">{modalTitle}</h3>
              <button onClick={closeModal} className="footer-modal-close-btn" aria-label="Close">✕</button>
            </div>
            <p className="footer-modal-body">{modalContent}</p>
            <button onClick={closeModal} className="footer-modal-confirm">Got it</button>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;